import { useQuery } from '@tanstack/react-query';
import { UserQueryKeys } from './constants';
import { server } from 'common/services/server/server';
import useProfileStore from '../../zustand/userStore';
import { useEffect } from 'react';
import { analytics } from 'common/services/analytics/Analytics';

export const useGetUser = () => {
  const { data: user, isLoading } = useQuery({
    queryKey: [UserQueryKeys.User],
    queryFn: ({ signal }) => server.getUser({ signal }),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
  const { setUserId } = useProfileStore();

  useEffect(() => {
    if (user) {
      setUserId(user.id);
      analytics.setUserId(user.id);
    }
  }, [user, setUserId]);

  return { user, isLoading };
};
